import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../../contexts/layout.context';
import actions from '../../../store/actions';
import { useDispatch } from 'react-redux';

import Head from '../../../components/Head/Head';
import InstagramForm from '../../../components/Profile/Edit/InstagramForm/InstagramForm';

const EditInstgram = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна instagram' goBack={goBack} />
      <div className="profile__content">
        <InstagramForm />
      </div>
    </div>
  );
};

export default EditInstgram;